import type { HeroSlide } from '@/types';

export const heroSlides: HeroSlide[] = [
  {
    id: 'slide-1',
    backgroundImage: '/hero-slide-1.jpg',
    title: 'La calidad no es opcional, es esencial.',
    description: 'Asegura la durabilidad de tu proyecto con nuestras pruebas de calidad de los materiales.',
    ctaText: 'Solicitar información',
    ctaLink: '#cotiza',
  },
  {
    id: 'slide-2',
    backgroundImage: '/hero-slide-2.jpg',
    title: 'Tecnología de punta para vías férreas',
    description: 'Ultrasonido: Precisión y confiabilidad en cada inspección.',
    ctaText: 'Solicitar información',
    ctaLink: '#cotiza',
  },
  {
    id: 'slide-3',
    backgroundImage: '/hero-slide-3.jpg',
    title: ' Puentes, edificios y grande obras',
    description: 'Garantiza la calidad e integridad de cimentaciones profundas con tecnología ultrasónica Cross- Hole.',
    ctaText: 'Solicitar información',
    ctaLink: '#cotiza',
  },
];